/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

// import components below
import Layout from 'components/Layout';
import PageHeader from './components/PageHeader';
import SideBar from 'components/ACLComponents/SideBar';
import ActivitiesContainer from './components/ActivitiesContainer';

// main component
const Activities = () => {
  return (
    <Layout pageTitle='Activities'>
      <PageHeader />

      <Row className='mt-4'>
        <Col sm={9}>
          <ActivitiesContainer />
        </Col>
        <Col sm={3}>
          <SideBar />
        </Col>
      </Row>
    </Layout>
  );
};

export default Activities;
